import { lazy } from "react";

// project import
import Loadable from "components/Loadable";
import DashboardLayout from "layout/Dashboard";
import PagesLayout from "layout/Pages";
import SimpleLayout from "layout/Simple";
import { SimpleLayoutType } from "config";
        

//-------------------------------------
// Template pages routing
const AuthLogin = Loadable(lazy(() => import("pages/auth/login")));
const AuthRegister = Loadable(lazy(() => import("pages/auth/register")));
const AuthForgotPassword = Loadable(lazy(() => import("pages/auth/forgot-password")));
const AuthResetPassword = Loadable(lazy(() => import("pages/auth/reset-password")));
const AuthResetPasswordResponse = Loadable(lazy(() => import("pages/auth/reset-password-confirmation")));
const AuthCheckMail = Loadable(lazy(() => import("pages/auth/check-mail")));
const AuthCodeVerification = Loadable(lazy(() => import("pages/auth/code-verification")));
const AuthLogout = Loadable(lazy(() => import("pages/auth/logout")));

const MaintenanceError = Loadable(lazy(() => import("pages/maintenance/404")));
const MaintenanceError500 = Loadable(lazy(() => import("pages/maintenance/500")));
const MaintenanceUnderConstruction = Loadable(lazy(() => import("pages/maintenance/under-construction")));
const MaintenanceComingSoon = Loadable(lazy(() => import("pages/maintenance/coming-soon")));


//-------------------------------------
// Tasks Board
const TasksBoard = Loadable(lazy(() => import("apps/tasks-kanban-board")));



//-------------------------------------
// pages routing

const DashboardRouter = Loadable(lazy(() => import("pages/router")));
const DashboardPrincipal = Loadable(lazy(() => import("pages/dashboards/principal")));
const DashboardTemporal = Loadable(lazy(() => import("pages/dashboards/boiler-plate")));

// WhatsApp module
const WhatsappPage = Loadable(lazy(() => import("pages/content/whatsapp")));

// Kanban module
const KanbanPage = Loadable(lazy(() => import("pages/content/kanban")));

// Templates
const TableListStandard = Loadable(lazy(() => import("pages/templates/table-list-standard")));
const TableListDateRange = Loadable(lazy(() => import("pages/templates/table-list-date-range")));
const SimplePage = Loadable(lazy(() => import("pages/templates/simple-page")));
const Esignature = Loadable(lazy(() => import("pages/templates/esignature")));
const WidgetIndicadorMinMaxDemo = Loadable(lazy(() => import("pages/templates/widget-indicador-minmax")));
const TableListSelector = Loadable(lazy(() => import("pages/templates/table-list-selector")));
const SingleComponents = Loadable(lazy(() => import("pages/templates/single-components")));
const TableSelectorModal = Loadable(lazy(() => import("pages/templates/table-selector-modal")));

const Saludo = Loadable(lazy(() => import("pages/templates/saludo")));
const Cliente = Loadable(lazy(() => import("pages/templates/cliente")));


const Modals = Loadable(lazy(() => import("pages/templates/modals")));
const ModalFormDummy = Loadable(lazy(() => import("pages/templates/modal-form-dummy")));


// Admin
const Eventos = Loadable(lazy(() => import("pages/admin/eventos")));
const UsuariosSistema = Loadable(lazy(() => import("pages/admin/usuarios-sistema")));
const Beneficiarios = Loadable(lazy(() => import("pages/admin/beneficiarios")));
const CrearBeneficiario = Loadable(lazy(() => import("pages/admin/beneficiarios/crear-beneficiario")));
const ListadoEvento = Loadable(lazy(() => import("pages/admin/beneficiarios/listado-evento")));
const ListadoGeneral = Loadable(lazy(() => import("pages/admin/beneficiarios/listado-general")));
const DirectorioMedicoListadoEvento = Loadable(lazy(() => import("pages/admin/directorio-medico/listado-evento")));
const DirectorioMedicoDirectorio = Loadable(lazy(() => import("pages/admin/directorio-medico/directorio")));
const VoluntariosListadoEvento = Loadable(lazy(() => import("pages/admin/voluntarios/listado-evento")));
const VoluntariosListadoGeneral = Loadable(lazy(() => import("pages/admin/voluntarios/listado-general")));
const ConsentimientoBeneficiarios = Loadable(lazy(() => import("pages/admin/documentos/consentimiento-beneficiarios")));
const AcuerdoVoluntarios = Loadable(lazy(() => import("pages/admin/documentos/acuerdo-voluntarios")));

// Data
const EstadisticaBeneficiarios = Loadable(lazy(() => import("pages/data/estadistica/beneficiarios")));
const EstadisticaFactoresRiesgo = Loadable(lazy(() => import("pages/data/estadistica/factores-riesgo")));
const EstadisticaDemografia = Loadable(lazy(() => import("pages/data/estadistica/demografia")));
const EstadisticaSeguimientoPostEvento = Loadable(lazy(() => import("pages/data/estadistica/seguimiento-post-evento")));
const EstadisticaEventos = Loadable(lazy(() => import("pages/data/estadistica/eventos")));
const EstadisticaEncuestaSalida = Loadable(lazy(() => import("pages/data/estadistica/encuesta-salida")));
const ReporteEvento = Loadable(lazy(() => import("pages/data/reporte-evento")));
const Formularios = Loadable(lazy(() => import("pages/data/formularios")));

// Evento
const AdministradorCircuito = Loadable(lazy(() => import("pages/circuito/circuit-manager")));
const SVSomatometria = Loadable(lazy(() => import("pages/circuito/estaciones-pruebas/sv-somatometria")));
const SignosVitales = Loadable(lazy(() => import("pages/circuito/estaciones-pruebas/signos-vitales")));
const MuestrasSanguineas = Loadable(lazy(() => import("pages/circuito/estaciones-pruebas/muestras-sanguineas")));
const Electrocardiograma = Loadable(lazy(() => import("pages/circuito/estaciones-pruebas/electrocardiograma")));
const Ecocardiograma = Loadable(lazy(() => import("pages/circuito/estaciones-pruebas/ecocardiograma")));
const EvaluacionCardiovascular = Loadable(lazy(() => import("pages/circuito/estaciones-pruebas/evaluacion-cardiovascular")));
const SesionPlaticas = Loadable(lazy(() => import("pages/circuito/estaciones-pruebas/sesion-platicas")));
const CursoRCP = Loadable(lazy(() => import("pages/circuito/estaciones-pruebas/curso-rcp")));
const Monitor = Loadable(lazy(() => import("pages/circuito/monitor")));
const CheckinBeneficiario = Loadable(lazy(() => import("pages/circuito/checkin-beneficiario")));
const CheckinVoluntario = Loadable(lazy(() => import("pages/circuito/checkin-voluntario")));

// Acceso Libre
const Alta = Loadable(lazy(() => import("pages/acceso-libre/alta-beneficiario")));
const RegistroConfirmacionBeneficiario = Loadable(lazy(() => import("pages/acceso-libre/alta-beneficiario/registro-confirmacion")));
const RegistroConfirmacionVoluntario = Loadable(lazy(() => import("pages/acceso-libre/alta-voluntario/registro-confirmacion")));
const Beneficiario = Loadable(lazy(() => import("pages/acceso-libre/beneficiario")));
const EvaluacionDashboard = Loadable(lazy(() => import("pages/acceso-libre/evaluacion/dashboard")));
const AltaVoluntario = Loadable(lazy(() => import("pages/acceso-libre/alta-voluntario")));
const EvaluacionCita = Loadable(lazy(() => import("pages/acceso-libre/evaluacion/agenda-citas")));
const EvaluacionEncuesta = Loadable(lazy(() => import("pages/acceso-libre/evaluacion/encuesta-post-evento")));
const EventoPublico = Loadable(lazy(() => import("pages/acceso-libre/pagina-informativa-evento")));
const EventoProximo = Loadable(lazy(() => import("pages/acceso-libre/evento-proximo")));


// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  children: [
    {
      path: "/",
      element: <DashboardLayout />,
      children: [
        {
          path: "home",
          children: [
            {
              path: "",
              element: <DashboardRouter />,
            },
          ],
        },
        {
          path: "dashboard",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <DashboardTemporal />,
            },
            {
              path: "principal",
              element: <DashboardPrincipal />,
            },
          ],
        },
        {
          path: "templates",
          element: <PagesLayout />,
          children: [
            {
              path: "table-list-standard",
              element: <TableListStandard />,
            },
            {
              path: "saludo",
              element: <Saludo />,
            },
            {
              path: "table-list-date-range",
              element: <TableListDateRange />,
            },
            {
              path: "simple-page",
              element: <SimplePage />,
            },
            {
              path: "esignature",
              element: <Esignature />,
            },
            {
              path: "widget-indicador-minmax",
              element: <WidgetIndicadorMinMaxDemo />,
            },
            {
              path: "table-list-selector",
              element: <TableListSelector />,
            },
            {
              path: "single-components",
              element: <SingleComponents />,
            },
            {
              path: "table-selector-modal",
              element: <TableSelectorModal />,
            },
            {
              path: "modals",
              element: <Modals />,
            },
            {
              path: "modal-form-dummy",
              element: <ModalFormDummy />,
            },
            {
              path: "cliente",
              element: <Cliente />,
            },
          ],
        },
        {
          path: "admin",
          element: <PagesLayout />,
          children: [
            {
              path: "eventos",
              element: <Eventos />,
            },
            {
              path: "usuarios-sistema",
              element: <UsuariosSistema />,
            },
            {
              path: "beneficiarios",
              element: <Beneficiarios />,
            },
            {
              path: "beneficiarios/crear-beneficiario",
              element: <CrearBeneficiario />,
            },
            {
              path: "beneficiarios/listado-evento",
              element: <ListadoEvento />,
            },
            {
              path: "beneficiarios/listado-general",
              element: <ListadoGeneral />,
            },
            {
              path: "directorio-medico/listado-evento",
              element: <DirectorioMedicoListadoEvento />,
            },
            {
              path: "directorio-medico/directorio",
              element: <DirectorioMedicoDirectorio />,
            },
            {
              path: "voluntarios/listado-evento",
              element: <VoluntariosListadoEvento />,
            },
            {
              path: "voluntarios/listado-general",
              element: <VoluntariosListadoGeneral />,
            },
            {
              path: "documentos/consentimiento-beneficiarios",
              element: <ConsentimientoBeneficiarios />,
            },
            {
              path: "documentos/acuerdo-voluntarios",
              element: <AcuerdoVoluntarios />,
            },
          ],
        },
        {
          path: "data",
          element: <PagesLayout />,
          children: [
            {
              path: "estadistica/beneficiarios",
              element: <EstadisticaBeneficiarios />,
            },
            {
              path: "estadistica/factores-riesgo",
              element: <EstadisticaFactoresRiesgo />,
            },
            {
              path: "estadistica/demografia",
              element: <EstadisticaDemografia />,
            },
            {
              path: "estadistica/seguimiento-post-evento",
              element: <EstadisticaSeguimientoPostEvento />,
            },
            {
              path: "estadistica/eventos",
              element: <EstadisticaEventos />,
            },
            {
              path: "estadistica/encuesta-salida",
              element: <EstadisticaEncuestaSalida />,
            },

            {
              path: "reporte-evento",
              element: <ReporteEvento />,
            },
            {
              path: "formularios",
              element: <Formularios />,
            },
          ],
        },
        {
          path: "circuito",
          element: <PagesLayout />,
          children: [
            {
              path: "administrador-circuito",
              element: <AdministradorCircuito />,
            },
            {
              path: "checkin-beneficiario",
              element: <CheckinBeneficiario />,
            },
            {
              path: "checkin-voluntario",
              element: <CheckinVoluntario />,
            },
          ],
        },
        {
          path: "whatsapp",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <WhatsappPage />,
            },
          ],
        },
        {
          path: "kanban",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <KanbanPage />,
            },
          ],
        },
        {
          path: "tasks-board",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <TasksBoard />,
            },
          ],
        },
        
      ],
    },

    {
      path: "/circuito/monitor",
      element: <PagesLayout />,
      children: [
        {
          path: "",
          element: <Monitor />,
        },
      ],
    },

    {
      path: "/circuito/estaciones-pruebas",
      element: <PagesLayout />,
      children: [
        {
          path: "sv-somatometria",
          element: <SVSomatometria />,
        },
        {
          path: "signos-vitales",
          element: <SignosVitales />,
        },
        {
          path: "muestras-sanguineas",
          element: <MuestrasSanguineas />,
        },
        {
          path: "electrocardiograma",
          element: <Electrocardiograma />,
        },
        {
          path: "ecocardiograma",
          element: <Ecocardiograma />,
        },
        {
          path: "evaluacion-cardiovascular",
          element: <EvaluacionCardiovascular />,
        },
        {
          path: "sesion-platicas",
          element: <SesionPlaticas />,
        },
        {
          path: "curso-rcp",
          element: <CursoRCP />,
        },
      ],
    },

    {
      path: "/",
      element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
      children: [
        {
          path: "evento",
          element: <EventoPublico />,
        },
        {
          path: "evento-proximo",
          element: <EventoProximo />,
        },
        {
          path: "alta",
          element: <Alta />,
        },
        {
          path: "alta/registro-confirmacion",
          element: <RegistroConfirmacionBeneficiario />,
        },
        {
          path: "alta/voluntario",
          element: <AltaVoluntario />,
        },
        {
          path: "alta/voluntario/registro-confirmacion",
          element: <RegistroConfirmacionVoluntario />,
        },
        {
          path: "beneficiario",
          element: <Beneficiario />,
        },
        {
          path: "evaluacion/dashboard",
          element: <EvaluacionDashboard />,
        },
        {
          path: "evaluacion/cita",
          element: <EvaluacionCita />,
        },
        {
          path: "evaluacion/encuesta",
          element: <EvaluacionEncuesta />,
        },
        
      ],
    },

    

    {
      path: "/maintenance",
      element: <PagesLayout />,
      children: [
        {
          path: "404",
          element: <MaintenanceError />,
        },
        {
          path: "500",
          element: <MaintenanceError500 />,
        },
        {
          path: "under-construction",
          element: <MaintenanceUnderConstruction />,
        },
        {
          path: "coming-soon",
          element: <MaintenanceComingSoon />,
        },
      ],
    },
    
    {
      path: "/auth",
      element: <PagesLayout />,
      children: [
        {
          path: "login",
          element: <AuthLogin />,
        },
        {
          path: "register",
          element: <AuthRegister />,
        },
        {
          path: "forgot-password",
          element: <AuthForgotPassword />,
        },
        {
          path: "reset-password",
          element: <AuthResetPassword />,
        },
        {
          path: "reset-password-confirmation",
          element: <AuthResetPasswordResponse />,
        },
        {
          path: "check-mail",
          element: <AuthCheckMail />,
        },
        {
          path: "code-verification",
          element: <AuthCodeVerification />,
        },
        {
          path: "logout",
          element: <AuthLogout />,
        },
      ],
    },
    {
      path: "/",
      element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
      children: [
        {
          path: "contact-us",
          element: <MaintenanceComingSoon />,
        },
      ],
    },
    {
      path: "*",
      element: <MaintenanceError />,
    },
  ],
};

export default MainRoutes;
